import { deviceManagementNavigation } from '../domain/navigation.util';

export default deviceManagementNavigation;
